import commentIconSvg from '@superdoc/common/icons/comment-solid.svg?raw';
import caretDownIconSvg from '@superdoc/common/icons/caret-down-solid.svg?raw';
import userCheckIconSvg from '@superdoc/common/icons/user-check-solid.svg?raw';
import usersIconSvg from '@superdoc/common/icons/users-solid.svg?raw';
import checkIconSvg from '@superdoc/common/icons/check-solid.svg?raw';
import xmarkIconSvg from '@superdoc/common/icons/xmark-solid.svg?raw';
import ellipsisVerticalSvg from '@superdoc/common/icons/ellipsis-vertical-solid.svg?raw';

export const superdocIcons = {
  comment: commentIconSvg,
  caretDown: caretDownIconSvg,
  internal: userCheckIconSvg,
  external: usersIconSvg,
  markDone: checkIconSvg,
  acceptChange: checkIconSvg,
  rejectChange: xmarkIconSvg,
  overflow: ellipsisVerticalSvg,
};
